module.exports = __webpack_public_path__ + "media/images/icons/filled/taobao-square-be9955302df680f96855f6f77dd39bf5.svg";